// Phase 6 — track whether we've gone offline-long-enough to surface the
// quiet chip. README §9: silent for up to 60 s; chip appears after.

import { useEffect, useState } from 'react';
import { useAppStore } from '../state/store';
import { OFFLINE_THRESHOLD_MS, isOffline } from './tickController';

export function useOffline(): boolean {
  const lastServerSeenAt = useAppStore((s) => s.lastServerSeenAt);
  const [offline, setOffline] = useState<boolean>(false);

  useEffect(() => {
    const id = setInterval(() => {
      setOffline(isOffline(lastServerSeenAt, performance.now(), OFFLINE_THRESHOLD_MS));
    }, 1000);
    return () => clearInterval(id);
  }, [lastServerSeenAt]);

  return offline;
}
